import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, TextField, Button, Typography, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { useShippingProfile } from '../contexts/ShippingProfileContext';
import useTranslation from '../../../hooks/useTranslation';

const ShippingCarrierModal = ({ open, onClose, carrier = null }) => {
  const { t } = useTranslation();
  const { selectedCarriers, setSelectedCarriers } = useShippingProfile();

  const [carrierData, setCarrierData] = useState({
    name: '',
    tracking_url: '',
    carrier_type: 'custom',
    fulfillment_center_id: null,
  });

  const [validationErrors, setValidationErrors] = useState({});

  useEffect(() => {
    if (carrier) {
      setCarrierData({
        name: carrier.name || '',
        tracking_url: carrier.tracking_url || '',
        carrier_type: carrier.carrier_type || 'custom',
        fulfillment_center_id: carrier.fulfillment_center_id || null,
      });
    } else {
      setCarrierData({
        name: '',
        tracking_url: '',
        carrier_type: 'custom',
        fulfillment_center_id: null,
      });
    }
  }, [carrier]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCarrierData({ ...carrierData, [name]: value });
  };

  const validate = () => {
    const errors = {};
    if (!carrierData.name) {
      errors.name = t('labels.shipping_carrier_modal.name_required');
    }
    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSave = () => {
    if (validate()) {
      if (carrier) {
        const updatedCarriers = selectedCarriers.map((existingCarrier) =>
          existingCarrier.name === carrier.name ? carrierData : existingCarrier
        );
        setSelectedCarriers(updatedCarriers);
      } else {
        setSelectedCarriers([...selectedCarriers, carrierData]);
      }
      onClose();
    }
  };

  return (
    <Modal open={open} onClose={onClose} aria-labelledby="shipping-carrier-modal">
      <div
        style={{
          padding: 20,
          maxWidth: 500,
          margin: '50px auto',
          backgroundColor: 'white',
          borderRadius: 8,
        }}
      >
        <Typography variant="h6">
          {carrier ? t('labels.shipping_carrier_modal.edit_carrier') : t('labels.shipping_carrier_modal.add_carrier')}
        </Typography>
        <TextField
          label={t('labels.shipping_carrier_modal.carrier_name')}
          name="name"
          variant="outlined"
          fullWidth
          margin="normal"
          value={carrierData.name}
          onChange={handleChange}
          error={!!validationErrors.name}
          helperText={validationErrors.name}
        />
        <TextField
          label={t('labels.shipping_carrier_modal.tracking_url')}
          name="tracking_url"
          variant="outlined"
          fullWidth
          margin="normal"
          value={carrierData.tracking_url}
          onChange={handleChange}
        />
        <FormControl fullWidth margin="normal" disabled>
          <InputLabel>{t('labels.shipping_carrier_modal.carrier_type')}</InputLabel>
          <Select name="carrier_type" value="custom" onChange={handleChange}>
            <MenuItem value="custom">{t('labels.shipping_carrier_modal.custom')}</MenuItem>
          </Select>
        </FormControl>
        <div style={{ marginTop: 20, display: 'flex', justifyContent: 'space-between' }}>
          <Button variant="outlined" onClick={onClose}>
            {t('labels.shipping_carrier_modal.cancel')}
          </Button>
          <Button variant="contained" color="primary" onClick={handleSave}>
            {t('labels.shipping_carrier_modal.save')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

ShippingCarrierModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  carrier: PropTypes.object,
};

export default ShippingCarrierModal;